<script setup lang="ts">
import { NxtInput } from '@future-harry/nxt-styles';
import MediaSelector from '@/core/components/form-elements/MediaSelector.vue';

const model = defineModel<any>();

const props = defineProps<{
   errors: Record<string, string>;
}>();
</script>

<template>
   <MediaSelector v-model="model.image.url" v-model:media-id="model.image_id" :error="props.errors['image.url']" />
   <NxtInput
      name="alt"
      :label="$t('live-editor.content-blocks.image.alt_text')"
      :description="$t('live-editor.content-blocks.image.alt_text_description')"
      :errors="props.errors"
      v-model="model.alt"
   />
   <NxtInput name="url" :label="$t('live-editor.content-blocks.image.url')" :errors="props.errors" v-model="model.url" />
</template>
